import React from 'react';

import { useUnit } from 'effector-react';
import { RouteProps, Navigate } from 'react-router-dom';

import { User$, TUser$State } from '../../effector/user';
import { ProtectedProps } from '../../hoc/withProtection';
import { checkPermissions, UserAction } from '../../utils/permissions';
import { PAGE_LOGIN, PAGE_ROOT } from '../Routes';

type Props = RouteProps & {
  component: React.FC<ProtectedProps>;
  userAction: UserAction;
};

export const PrivateRoute: React.FC<Props> = ({ component: Component, userAction }) => {
  const user = useUnit<TUser$State>(User$);

  if (user?.role && checkPermissions(user.role, userAction)) {
    return <Component role={user.role} action={userAction} />;
  }

  if (user?.role) {
    return <Navigate replace to={PAGE_ROOT} />;
  }

  return <Navigate to={PAGE_LOGIN} />;
};
